export default __webpack_public_path__ + "static/media/messenger.6a55a815.svg";